import { createFileRoute, redirect } from '@tanstack/react-router'
import { useAuthStore } from '@/stores/authStore'
import CabinetBilling from '@/views/cabinet/billing'

export const Route = createFileRoute('/_authenticated/cabinet-billing')({
  beforeLoad: async () => {
    const auth = useAuthStore.getState().auth

    if (!auth.accessToken || !auth.user) {
      throw redirect({ to: '/auth/login' })
    }

    // Restrict to cabinet admins (not super admins)
    if (auth.user.role === 'Super Admin' || auth.user.is_admin !== true) {
      throw redirect({ to: '/dashboard' })
    }
  },
  component: CabinetBilling,
})